module.exports = __webpack_public_path__ + "media/images/application/template/sagepay-7db2b66e7d2d6feb410f9ec0fd02c75c.png";